import {ISettingsParam, ISettingsSetter, SettingsParamType} from '@wix/tpa-settings'
import {useSettings as useTpaSettings} from '@wix/tpa-settings/react'

interface UseSettingsParams {
  isSettings?: boolean
  reportSettingChangedBi?: (settingKey: string, value: string) => void
}

export const useSettings = ({isSettings, reportSettingChangedBi}: UseSettingsParams = {}) => {
  const settings = useTpaSettings()

  const shouldFallbackToDefault = (param: ISettingsParam) => {
    return param.type === SettingsParamType.Text && param.getDefaultValue && !isSettings
  }

  const get = (param: ISettingsParam) => {
    const value = settings.get(param)

    return shouldFallbackToDefault(param) && !value ? settings.getDefaultValue(param) : value
  }

  const getWithFallback = (param: ISettingsParam, fallbackParam: ISettingsParam) => {
    const value = get(param)
    const fallbackValue = get(fallbackParam)

    return value ?? fallbackValue
  }

  const set: ISettingsSetter = (param, value) => {
    if (reportSettingChangedBi) {
      reportSettingChangedBi(param.key, value)
    }

    settings.set(param, value)
  }

  return {
    ...settings,
    get,
    getWithFallback,
    set,
  }
}
